module.exports = __webpack_public_path__ + "static/media/PricingDQWorkspace5.0b355dea.png";